import React from 'react'

import IFormPage from '../../../../interfaces/form-page'
import FormFactory from '../../../../components/form/form-factory'
import Preview1Png from '../../../../assets/jpg/finger-demo.jpeg'

import {
  Container,
  FormWrapper,
} from './styles'
import Title from '../../../../components/form/formik/title'
import Guide from '../../../../components/guide'

type IProps = any & IFormPage

const MenuOrganization = ({
  dataForm,
  onSubmit,
  menuOptionsData,
  initialData,
}: IProps) => (
  <Container>
    <Title
      style={{ marginTop: '0' }}
      title="Descrição e logo do cardápio"
    />
    <FormWrapper>
      <div className="form">
        <FormFactory
          setData={menuOptionsData}
          initialData={initialData}
          data={dataForm}
          onSubmit={onSubmit}
        />
      </div>

      <Guide
        title="Preview"
        img={Preview1Png}
      />
    </FormWrapper>

    {/* <Title
      title="Organize as categorias"
      subtitle="Arraste para que as categorias se encaixe na ordem que deseja"
    />
    <FormWrapper>
      <div className="form" style={{ maxWidth: '58.15%' }}>
        <CategoriesForm
          categoriesOptions={categoriesOptions}
          onSubmit={onSubmit}
          categories={categories}
          setCategories={setCategories}
        />
      </div>

      <Guide
        title="Preview"
        img={Preview2Png}
      />
    </FormWrapper> */}
  </Container>
)

export default MenuOrganization
